import DOMPurify from "dompurify";
import React from 'react'

  function SafeComponent({ html }) {
    const cleanHTML = DOMPurify.sanitize(html);

    return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
}

export default SafeComponent